import { FadeUp } from "../Reveal";
import { profile } from "../../data/content";
import { Code2, Cpu, LineChart, Zap } from "lucide-react";

const HIGHLIGHTS = [
  { icon: LineChart, title: "Finance systems", body: "Trading tools, risk engines, and reconciliations that hold up under pressure." },
  { icon: Cpu, title: "IoT and Hardware", body: "Solar-powered systems built for the field, not the lab." },
  { icon: Zap, title: "Electrical Engineering", body: "Circuit design, HVAC systems, and embedded electronics from coursework to deployment." },
  { icon: Code2, title: "Software", body: "Backend APIs, frontend interfaces, and the glue that holds systems together." }
];

export const About = () => {
  return (
    <section id="about" className="relative py-20 sm:py-28 border-t border-edge-650">
      <div className="container-page">
        <FadeUp>
          <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-magenta-300">About</div>
        </FadeUp>

        <FadeUp delay={0.05}>
          <h2 className="mt-4 font-display tracking-tight text-3xl sm:text-5xl text-white max-w-3xl leading-[1.05]">
            <span className="text-magenta-grad">A Short Story:</span> The Journey Continues.
          </h2>
        </FadeUp>

        <div className="mt-10 grid grid-cols-12 gap-y-10 lg:gap-x-12">
          <div className="col-span-12 lg:col-span-7">
            <FadeUp>
              <p className="text-zinc-300 text-base sm:text-lg leading-relaxed max-w-prose">{profile.longBio}</p>
            </FadeUp>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {HIGHLIGHTS.map((h, i) => (
                <FadeUp key={h.title} delay={0.05 + i * 0.05}>
                  <div className="group rounded-2xl border border-edge-650 bg-graphite-900/50 p-5 hover:border-magenta-500/40 transition-colors h-full">
                    <div className="flex items-center gap-3">
                      <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg border border-edge-700 bg-ink-900 text-magenta-300">
                        <h.icon className="w-4 h-4" />
                      </span>
                      <div className="font-display text-white text-base">{h.title}</div>
                    </div>
                    <p className="mt-3 text-sm text-zinc-400">{h.body}</p>
                  </div>
                </FadeUp>
              ))}
            </div>
          </div>

          <div className="col-span-12 lg:col-span-5">
            <FadeUp>
              <div className="relative rounded-2xl overflow-hidden bg-graphite-900/30 border border-edge-650 aspect-[4/5] lg:aspect-auto lg:h-[560px]">
                <div
                  className="absolute bg-no-repeat"
                  style={{
                    inset: "-8% 0 0 0",
                    backgroundImage: "url('/assets/malick-about.jpg')",
                    backgroundSize: "100% auto",
                    backgroundPosition: "50% 12%",
                    filter: "contrast(1.08) brightness(0.86) saturate(0.72)"
                  }}
                  aria-label="Portrait of Malicke Case"
                  role="img"
                />
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_85%_75%_at_50%_50%,transparent_30%,rgba(5,5,6,0.65)_70%,#050506_95%)]" />
                <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-ink-950 to-transparent" />
                <div className="absolute inset-x-0 top-0 h-1/4 bg-gradient-to-b from-ink-950/80 to-transparent" />

                <div className="absolute left-5 bottom-5 right-5 flex items-center justify-between">
                  <span className="font-mono text-[10px] tracking-[0.22em] uppercase text-zinc-400">{profile.role}</span>
                  <span className="font-mono text-[10px] tracking-[0.22em] uppercase text-magenta-300">M.CASE</span>
                </div>
              </div>
            </FadeUp>
          </div>
        </div>
      </div>
    </section>
  );
};
